export default {"src":"/_next/static/media/bonded.49d31c04.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};